<template>
  <svg class="donut-chart" :class="{ 'donut-chart--highlighting': highlighted }" viewBox="0 0 200 200">
    <circle
      v-for="segment in arcs"
      :key="segment.label"
      class="donut-chart__segment"
      :class="{ 'donut-chart__segment--highlighted': highlighted === segment.label }"
      cx="100"
      cy="100"
      :r="radius"
      fill="none"
      :stroke="highlighted === segment.label ? segment.hoverColor || segment.color : segment.color"
      :style="{ strokeWidth: highlighted === segment.label ? thickness + 6 : thickness }"
      :stroke-dasharray="`${segment.length} ${circumference - segment.length}`"
      :stroke-dashoffset="-segment.offset"
      transform="rotate(-90 100 100)"
      @mouseenter="$emit('hover', segment.label)"
      @mouseleave="$emit('hover', null)"
    >
      <title>{{ segment.label }}: {{ segment.value }}</title>
    </circle>
    <text x="100" y="104" text-anchor="middle" class="donut-chart__total">{{ total }}</text>
    <text x="100" y="124" text-anchor="middle" class="donut-chart__caption">{{ caption }}</text>
  </svg>
</template>

<script>
export default {
  name: 'DonutChart',
  props: {
    segments: {
      type: Array,
      default: () => [],
    },
    caption: {
      type: String,
      default: '',
    },
    // Label of the segment to draw in its hover color
    highlighted: {
      type: String,
      default: null,
    },
    radius: {
      type: Number,
      default: 80,
    },
    thickness: {
      type: Number,
      default: 32,
    },
  },
  computed: {
    total() {
      return this.segments.reduce((total, segment) => total + segment.value, 0)
    },
    circumference() {
      return 2 * Math.PI * this.radius
    },
    arcs() {
      let offset = 0

      return this.segments.map(segment => {
        const length = this.total > 0 ? (segment.value / this.total) * this.circumference : 0
        const arc = { ...segment, length, offset }
        offset += length
        return arc
      })
    },
  },
}
</script>

<style scoped>
/* Fills its container's width; the parent decides the size */
.donut-chart {
  display: block;
  width: 100%;
  height: auto;
}

.donut-chart__segment {
  cursor: pointer;
  transition:
    opacity 0.15s ease,
    stroke-width 0.15s ease;
}

.donut-chart--highlighting .donut-chart__segment {
  opacity: 0.35;
}

.donut-chart--highlighting .donut-chart__segment--highlighted {
  opacity: 1;
}

.donut-chart__total {
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 34px;
  font-weight: 700;
  fill: #1a1a1a;
}

.donut-chart__caption {
  font-size: 11px;
  fill: #6b6b6b;
}
</style>
